<template>
    <div v-show='showbadgemodal' class="badge-mask">
      <div class="badge-wrapper">
        <div class="badge-container">
            <div class="badge-image">
                <h1 class="badge-title">BADGE</h1>
                <img v-if="badge == 0" src="../assets/img/메달-인물.png" />
                <img v-else-if="badge == 1" src="../assets/img/메달-지리영토.png"/>
                <img v-else-if="badge == 2" src="../assets/img/메달-침탈.png"/>
                <img v-else-if="badge == 3" src="../assets/img/메달-역사.png"/>
                <img v-else-if="badge == 4" src="../assets/img/메달-생태자원.png"/>
                <img v-else src="../assets/img/메달-문화예술.png"/>
            </div>
            <div class="badge-text">
            <p>축하합니다!</p>
            <p>칙령 제41호 {{sections[badge]}}부 뱃지를 획득하셨습니다!</p>
            </div>
          <button class="badge-button" @click="showbadgemodal = false">
            OK
          </button>
        </div>
      </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
/* eslint-disable */
export default {
    data (){
        return {
            badge: '',
            badgeflag:[0,0,0,0,0,0],
            showbadgemodal:false, 
        }
    },
    computed:{
        ...mapState([
            'sections',
        ]),
        ...mapGetters([
            'sectionStates',
        ])
    },
    watch:{
        sectionStates: function(newVal) {
            var badge = this
            this.badgeflag.forEach((element,index) => {
                if (element != 1 && (index==0 || index==1 || index==3) && newVal[index] == 8 ){
                    badge.badge = index
                    badge.showbadgemodal = true
                    badge.badgeflag[index] = 1
                }
                if (element != 1 && (index==2) && newVal[index] == 7 ){
                    badge.badge = index
                    badge.showbadgemodal = true
                    badge.badgeflag[index] = 1
                }
                if (element != 1 && (index==4) && newVal[index] == 9 ){
                    badge.badge = index
                    badge.showbadgemodal = true
                    badge.badgeflag[index] = 1
                }
                if (element != 1 && (index==5) && newVal[index] == 6 ){
                    badge.badge = index
                    badge.showbadgemodal = true
                    badge.badgeflag[index] = 1
                }
            });
        }
    }
}
</script>

<style>
.badge-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.badge-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.badge-container {
  width: 370px;
  margin: 0px auto;
  padding: 20px 30px;
  border: black solid 5px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.badge-container p{
  text-align: center;
  font-size: 1.2em;
}
.badge-image{
    display: flex;
    justify-content: center;
    background-image: url('../assets/img/badge_background.png');
    background-size: contain;
    min-height: 350px;
    flex-direction: column;
    align-items: center;
}
.badge-title{
    text-align: center;
    font-size: 3em;
    font-family: 'american_typewriter', Courier, monospace;
    font-weight: bold;

}
.badge-text {
    margin-bottom: 1em;
}
.badge-button {
  display: block;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1em;
  width: 60%;
  margin: 0 20%;
  border: none;
  padding: 2%;
}
</style>



// WEBPACK FOOTER //
// src/components/badgeModal.vue